import classNames from 'classnames';
import React, { MouseEvent } from 'react';
import styles from './ColorPip.css';
import { Tooltip } from './tooltip';

export function ColorPip({
  leftHex,
  rightHex,
  name,
  active,
  onClick,
  chromaticMode,
}: {
  leftHex: string;
  rightHex: string;
  name: string;
  active: boolean;
  onClick: (e: MouseEvent) => void;
  chromaticMode: boolean;
}) {
  const anchorRef = React.useRef<HTMLDivElement>(null);

  return (
    <div
      ref={anchorRef}
      className={classNames(styles.container, active && styles.active)}
      onClick={onClick}
    >
      <div className={styles.pill}>
        <div
          className={classNames(
            styles.segment,
            chromaticMode && styles.chromaticMode,
          )}
          style={{ background: leftHex }}
        />
        <div
          className={classNames(
            styles.segment,
            chromaticMode && styles.chromaticMode,
          )}
          style={{ background: rightHex }}
        />
      </div>
      <Tooltip label={name} placement="vertical" anchorRef={anchorRef} />
    </div>
  );
}
